import { IViewMode, ViewModeType } from '../store/types';
import { DaysViewMode } from './DaysViewMode';
import { HoursViewMode } from './HoursViewMode';
import { MonthsViewMode } from './MonthsViewMode';
import { WeeksViewMode } from './WeeksViewMode';

export const ViewModes: { [type: string]: IViewMode } = {
  [ViewModeType.Days]: new DaysViewMode() as IViewMode,
  [ViewModeType.Weeks]: new WeeksViewMode() as IViewMode,
  [ViewModeType.Months]: new MonthsViewMode() as IViewMode,
  [ViewModeType.Hours]: new HoursViewMode() as IViewMode
};



// WEBPACK FOOTER //
// ./src/viewModes/index.ts